import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PDFDocument } from 'pdf-lib'
import { FileHelper } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-activity-compare-three-housing-units-rw',
  templateUrl: './page-activity-compare-three-housing-units-rw.component.html',
  styleUrls: ['./page-activity-compare-three-housing-units-rw.component.css', '../module-page-rw/module-page-rw.component.css']
})
export class PageActivityCompareThreeHousingUnitsRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  content = {
    downloaded: false,
    validate:   false,
  };

  pdfHandoutFillable!: PDFDocument;

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  async ngOnInit(): Promise<void> {
    const handoutFillablePdfBytes = await fetch("../../../../../assets/RWM3A3Handout.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable = await PDFDocument.load(handoutFillablePdfBytes);
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  async downloadHandoutPdf () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable.save();
    FileHelper.saveByteArray('RWM3A3Handout.pdf', pdfBytes, 'application/pdf');
  }
}
